(()=>{
const themes = [
  { id: 'all', label: 'All designs' },
  { id: 'trainers', label: 'Trainers' },
  { id: 'music', label: 'Music' },
  { id: 'football', label: 'Football' },
  { id: 'characters', label: 'Characters' },
  { id: 'seasonal', label: 'Seasonal' }
];

const products = [
  {
    id: 'air-max-90', name: 'Air Max 90', category: 'Trainer collection', themes: ['trainers'],
    tagline: 'An icon, illuminated.',
    description: 'The recognisable Air Max 90 profile in blue, white and black. The illuminated shoe shape brings the layered panels and signature air unit into focus.',
    detail: 'A side-profile trainer design with blue accents, a white midsole and a dark outline.',
    colors: [{name:'Blue',hex:'#3277d6'},{name:'White',hex:'#f0f4f8'},{name:'Black',hex:'#17191f'}],
    alt: 'Actual blue, white and black Air Max 90 lightbox illuminated on a desk beside a brick wall.'
  },
  {
    id: 'oasis-gazelle', name: 'Oasis Live ’27 Gazelle', category: 'Trainers × music', themes: ['trainers','music'],
    tagline: 'Two favourites. One design.',
    description: 'A cyan Gazelle trainer lightbox with Oasis Live ’27 graphics. The silhouette portraits, three stripes and lettering bring the music theme into the shoe itself.',
    detail: 'Cyan and blue trainer artwork with Oasis lettering and portrait details.',
    colors: [{name:'Cyan',hex:'#20c8ea'},{name:'Blue',hex:'#285add'},{name:'Dark outline',hex:'#17191f'}],
    alt: 'Actual cyan and blue Oasis Live 27 Gazelle trainer lightbox glowing on a tabletop.'
  },
  {
    id: 'guns-n-roses', name: 'Guns N’ Roses', category: 'Music collection', themes: ['music'],
    tagline: 'Turn up the atmosphere.',
    description: 'A circular Guns N’ Roses design with bright lettering, crossed guns and red rose details. Its high-contrast artwork stands out against the dark round face.',
    detail: 'A circular music design with white artwork and red accents.',
    colors: [{name:'White',hex:'#f0f4f8'},{name:'Red',hex:'#dc3d50'},{name:'Black',hex:'#17191f'}],
    alt: 'Actual circular Guns N Roses lightbox with white lettering and red roses on a dark desk.'
  },
  {
    id: 'manchester-united', name: 'Manchester United', category: 'Football collection', themes: ['football'],
    tagline: 'Club colours, centre stage.',
    description: 'The Manchester United crest in a shaped lightbox, with bold red and yellow artwork and illuminated lettering around the club emblem.',
    detail: 'A crest-shaped football design with a dark outer edge.',
    colors: [{name:'Red',hex:'#ec3c38'},{name:'Yellow',hex:'#efd956'},{name:'White',hex:'#f0f4f8'},{name:'Black',hex:'#17191f'}],
    alt: 'Actual illuminated Manchester United crest lightbox with red and yellow details.'
  },
  {
    id: 'air-jordan', name: 'Blue High-Top', category: 'Trainer collection', themes: ['trainers'],
    tagline: 'A classic from every angle.',
    description: 'A blue, white and black high-top trainer lightbox. The ankle panel, laces and sole are picked out in a clean side-profile design.',
    detail: 'A high-top shoe silhouette with bright white panels and blue overlays.',
    colors: [{name:'Blue',hex:'#2874d5'},{name:'White',hex:'#f0f4f8'},{name:'Black',hex:'#17191f'}],
    alt: 'Actual blue, white and black high-top trainer lightbox standing on a white surface.'
  },
  {
    id: 'oasis', name: 'Oasis Silhouettes', category: 'Music collection', themes: ['music'],
    tagline: 'Instantly recognisable.',
    description: 'Two bright silhouette portraits above the Oasis wordmark. White light and a black background give the music-inspired design a simple, striking finish.',
    detail: 'A shaped double-portrait design above a rectangular wordmark base.',
    colors: [{name:'White',hex:'#f0f4f8'},{name:'Black',hex:'#17191f'}],
    alt: 'Actual Oasis lightbox with two illuminated white portrait silhouettes above the Oasis name.'
  },
  {
    id: 'air-max-plus', name: 'Air Max Plus', category: 'Trainer collection', themes: ['trainers'],
    tagline: 'Bold lines. Bright detail.',
    description: 'The flowing Air Max Plus trainer shape, with bright panels and red detailing. The curved side lines and air-unit details give this lightbox its distinctive look.',
    detail: 'A low-profile trainer design with red accents and a bright white face.',
    colors: [{name:'White',hex:'#f0f4f8'},{name:'Red',hex:'#ed4864'},{name:'Black',hex:'#17191f'}],
    alt: 'Actual illuminated Air Max Plus trainer lightbox with a white face and red outlines.'
  },
  {
    id: 'lightning-mcqueen', name: 'Lightning McQueen', category: 'Character collection', themes: ['characters'],
    tagline: 'A little racing character.',
    description: 'A bright red Lightning McQueen lightbox with the number 95, yellow lightning graphics and a smiling face. The shaped outline follows the character’s racing-car profile.',
    detail: 'A character-shaped racing car with red, yellow and white artwork.',
    colors: [{name:'Red',hex:'#f13c38'},{name:'Yellow',hex:'#f3df34'},{name:'White',hex:'#f0f4f8'},{name:'Black',hex:'#17191f'}],
    alt: 'Actual red Lightning McQueen number 95 lightbox with a reflection on a black surface.'
  },
  {
    id: 'paw-patrol', name: 'PAW Patrol', category: 'Character collection', themes: ['characters'],
    tagline: 'Big colour. Little heroes.',
    description: 'A PAW Patrol shield lightbox with bold lettering and a paw-print detail. The colourful badge-shaped design lights up against its dark outer border.',
    detail: 'A shield-shaped character logo with yellow, red and blue details.',
    colors: [{name:'Yellow',hex:'#f2e65a'},{name:'Red',hex:'#dd4a42'},{name:'Blue',hex:'#3c90ce'},{name:'White',hex:'#f0f4f8'}],
    alt: 'Actual illuminated PAW Patrol shield lightbox reflected in a dark tabletop.'
  },
  {
    id: 'halloween-pumpkin', name: 'Halloween Pumpkin', category: 'Seasonal collection', themes: ['seasonal'],
    tagline: 'A glow with a little mischief.',
    description: 'An orange jack-o’-lantern lightbox with a glowing carved grin and pointed eyes. The shaped pumpkin and curling stalk bring a seasonal touch to the collection.',
    detail: 'An orange pumpkin design with bright face cut-outs and a green edge.',
    colors: [{name:'Orange',hex:'#f47728'},{name:'Green',hex:'#6bbf52'},{name:'Bright face',hex:'#99e8ee'},{name:'Black',hex:'#17191f'}],
    alt: 'Actual orange Halloween pumpkin lightbox with illuminated eyes and a carved grin.'
  }
];

function selectProducts(theme = 'all', query = '') {
  const words = query.trim().toLocaleLowerCase('en-GB').split(/\s+/).filter(Boolean);
  return products.filter(p => (theme === 'all' || p.themes.includes(theme)) && words.every(word =>
    `${p.name} ${p.category} ${p.description} ${p.themes.join(' ')}`.toLocaleLowerCase('en-GB').includes(word)));
}

function getProduct(id) { return products.find(product => product.id === id); }

// Verified from the merchant's Shopify product catalogue.
const shop = {
  "origin": "https://uqbt0b-0b.myshopify.com",
  "currency": "GBP",
  "postagePence": 500,
  "postageLabel": "UK postage & packaging",
  "checkoutEnabled": true,
  "shippingVerified": true
};

const catalog = {
  "air-max-90": {
    "productId": "gid://shopify/Product/16196014899532",
    "variantId": "59223807721804",
    "pricePence": 1500,
    "status": "DRAFT",
    "handle": "air-max-90-led-lightbox"
  },
  "oasis-gazelle": {
    "productId": "gid://shopify/Product/16196016210252",
    "variantId": "59223809163596",
    "pricePence": 1500,
    "status": "DRAFT",
    "handle": "oasis-live-27-gazelle-led-lightbox"
  },
  "guns-n-roses": {
    "productId": "gid://shopify/Product/16196017422668",
    "variantId": "59223811162444",
    "pricePence": 1500,
    "status": "DRAFT",
    "handle": "guns-n-roses-led-lightbox"
  },
  "manchester-united": {
    "productId": "gid://shopify/Product/16196018897228",
    "variantId": "59223812997452",
    "pricePence": 1500,
    "status": "DRAFT",
    "handle": "manchester-united-led-lightbox"
  },
  "air-jordan": {
    "productId": "gid://shopify/Product/16196020633932",
    "variantId": "59223815160140",
    "pricePence": 1500,
    "status": "DRAFT",
    "handle": "blue-high-top-led-lightbox"
  },
  "oasis": {
    "productId": "gid://shopify/Product/16196021977420",
    "variantId": "59223816601932",
    "pricePence": 1500,
    "status": "DRAFT",
    "handle": "oasis-silhouettes-led-lightbox"
  },
  "air-max-plus": {
    "productId": "gid://shopify/Product/16196023255372",
    "variantId": "59223818699084",
    "pricePence": 1500,
    "status": "DRAFT",
    "handle": "air-max-plus-led-lightbox"
  },
  "lightning-mcqueen": {
    "productId": "gid://shopify/Product/16196024336716",
    "variantId": "59223819813196",
    "pricePence": 1500,
    "status": "DRAFT",
    "handle": "lightning-mcqueen-led-lightbox"
  },
  "paw-patrol": {
    "productId": "gid://shopify/Product/16196025418060",
    "variantId": "59223821156684",
    "pricePence": 1500,
    "status": "DRAFT",
    "handle": "paw-patrol-led-lightbox"
  },
  "halloween-pumpkin": {
    "productId": "gid://shopify/Product/16196026696012",
    "variantId": "59223822860620",
    "pricePence": 1500,
    "status": "DRAFT",
    "handle": "halloween-pumpkin-led-lightbox"
  }
};


const basketStorageKey = 'jacobs-lightboxes-basket-v1';
const money = pence => new Intl.NumberFormat('en-GB', { style: 'currency', currency: shop.currency }).format(pence / 100);

function cleanBasket(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
  const result = {};
  for (const [id, quantity] of Object.entries(value)) {
    if (!Object.hasOwn(catalog, id) || typeof quantity !== 'number' || !Number.isFinite(quantity)) continue;
    const count = Math.min(99, Math.max(0, Math.floor(quantity)));
    if (count) result[id] = count;
  }
  return result;
}

function basketTotals(basket) {
  const entries = Object.entries(cleanBasket(basket));
  const quantity = entries.reduce((sum, [, count]) => sum + count, 0);
  const subtotal = entries.reduce((sum, [id, count]) => sum + catalog[id].pricePence * count, 0);
  const postage = quantity ? shop.postagePence : 0;
  return { quantity, subtotal, postage, total: subtotal + postage };
}

function checkoutURL(basket) {
  const entries = Object.entries(cleanBasket(basket));
  if (!entries.length) return null;
  // Shopify cart permalinks use actual numeric variant IDs, followed by quantities.
  const lines = entries.map(([id, count]) => `${catalog[id].variantId}:${count}`).join(',');
  return `${shop.origin}/cart/${lines}`;
}

function checkoutReady(basket) {
  const ids = Object.keys(cleanBasket(basket));
  return ids.length > 0;
}


const $ = selector => document.querySelector(selector);
const filters = $('#theme-filters');
const grid = $('#product-grid');
const search = $('#search');
const dialog = $('#product-dialog');
let selectedTheme = 'all';
let activeProduct = null;
let activeSequence = [];
let returnFocus = null;
let copyVersion = 0;
const basketDialog = $('#basket-dialog');
let basket = readBasket();
let basketReturnFocus = null;
const escapeHTML = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

filters.innerHTML = themes.map(theme => `<button type="button" class="filter-button" data-theme="${theme.id}" aria-pressed="${theme.id === 'all'}">${theme.label}<span>${theme.id === 'all' ? products.length : products.filter(p => p.themes.includes(theme.id)).length}</span></button>`).join('');

function renderGallery() {
  const visible = selectProducts(selectedTheme, search.value);
  grid.innerHTML = visible.map((p, index) => `<button class="product-card" type="button" data-product="${p.id}" aria-haspopup="dialog" aria-label="View ${escapeHTML(p.name)} lightbox, ${money(catalog[p.id].pricePence)}"><span class="card-image"><img src="https://cdn.shopify.com/s/files/1/1088/3819/1436/files/jacobs-lightboxes-${p.id}.jpg" alt="${escapeHTML(p.alt)}" width="1000" height="900" loading="${index < 3 ? 'eager' : 'lazy'}" decoding="async"><span class="image-open" aria-hidden="true">↗</span></span><span class="card-info"><span><span class="card-category">${escapeHTML(p.category)}</span><strong class="card-name">${escapeHTML(p.name)}</strong><span class="card-price">${money(catalog[p.id].pricePence)}</span></span><span class="card-arrow" aria-hidden="true">↗</span></span></button>`).join('');
  const themeName = themes.find(t => t.id === selectedTheme).label;
  $('#result-count').textContent = `${visible.length} ${visible.length === 1 ? 'design' : 'designs'}${selectedTheme !== 'all' ? ` in ${themeName.toLowerCase()}` : ' in the collection'}${search.value.trim() ? ` matching “${search.value.trim()}”` : ''}`;
  $('#empty-state').hidden = visible.length > 0;
  $('#clear-search').hidden = !search.value;
  filters.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.theme === selectedTheme)));
}

function resetPhoto() {
  $('.dialog-shell').classList.remove('photo-expanded');
  $('#expand-photo').setAttribute('aria-pressed', 'false');
  $('#expand-photo span').textContent = 'Enlarge photo';
}

function showProduct(id, updateURL = true) {
  const product = getProduct(id);
  if (!product) return;
  if (basketDialog.open) closeBasket();
  const opening = !dialog.open;
  if (opening) {
    returnFocus = document.activeElement;
    const visible = selectProducts(selectedTheme, search.value).map(p => p.id);
    activeSequence = visible.includes(id) ? visible : products.map(p => p.id);
  }
  activeProduct = product;
  $('#detail-price').textContent = money(catalog[id].pricePence);
  $('#detail-quantity').value = '1';
  $('#quantity-minus').disabled = true;
  $('#quantity-plus').disabled = false;
  $('#add-status').textContent = '';
  $('#view-basket').hidden = true;
  resetPhoto();
  $('#detail-title').textContent = product.name;
  $('#detail-category').textContent = product.category.toUpperCase();
  $('#detail-tagline').textContent = product.tagline;
  $('#detail-description').textContent = product.description;
  $('#detail-shape').textContent = product.detail;
  $('#detail-image').src = `https://cdn.shopify.com/s/files/1/1088/3819/1436/files/jacobs-lightboxes-${product.id}.jpg`;
  $('#detail-image').alt = product.alt;
  $('#detail-themes').innerHTML = product.themes.map(id => `<span>${themes.find(t => t.id === id).label}</span>`).join('');
  $('#detail-colors').innerHTML = product.colors.map(color => `<span class="color-item"><i aria-hidden="true" style="background:${color.hex}"></i>${escapeHTML(color.name)}</span>`).join('');
  const index = activeSequence.indexOf(id);
  $('#detail-position').textContent = `${index + 1} / ${activeSequence.length}`;
  $('#previous-design').disabled = activeSequence.length < 2;
  $('#next-design').disabled = activeSequence.length < 2;
  $('#copy-status').textContent = '';
  copyVersion++;
  if (updateURL) history.replaceState(null, '', `${location.pathname}${location.search}#design=${product.id}`);
  if (opening) { dialog.showModal(); document.body.classList.add('modal-open'); $('#close-dialog').focus(); }
  dialog.scrollTop = 0;
}

function closeProduct(updateURL = true) {
  if (!dialog.open) return;
  dialog.close();
  activeProduct = null;
  copyVersion++;
  document.body.classList.remove('modal-open');
  resetPhoto();
  if (updateURL && location.hash.startsWith('#design=')) history.replaceState(null, '', `${location.pathname}${location.search}#collection`);
  if (returnFocus && document.contains(returnFocus)) returnFocus.focus({preventScroll:true});
}

function moveProduct(direction) {
  if (!activeProduct || activeSequence.length < 2) return;
  const index = activeSequence.indexOf(activeProduct.id);
  showProduct(activeSequence[(index + direction + activeSequence.length) % activeSequence.length]);
}

filters.addEventListener('click', event => {
  const button = event.target.closest('[data-theme]');
  if (!button) return;
  selectedTheme = button.dataset.theme;
  renderGallery();
});
search.addEventListener('input', renderGallery);
$('#clear-search').addEventListener('click', () => { search.value = ''; renderGallery(); search.focus(); });
$('#reset-filters').addEventListener('click', () => { selectedTheme = 'all'; search.value = ''; renderGallery(); filters.querySelector('button').focus(); });
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-product]');
  if (!trigger) return;
  event.preventDefault();
  showProduct(trigger.dataset.product);
});
$('#close-dialog').addEventListener('click', () => closeProduct());
dialog.addEventListener('cancel', event => { event.preventDefault(); closeProduct(); });
dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeProduct(); } });
$('#previous-design').addEventListener('click', () => moveProduct(-1));
$('#next-design').addEventListener('click', () => moveProduct(1));
document.addEventListener('keydown', event => {
  if (!dialog.open || event.altKey || event.ctrlKey || event.metaKey || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
  if (event.key === 'ArrowRight') { event.preventDefault(); moveProduct(1); }
  if (event.key === 'ArrowLeft') { event.preventDefault(); moveProduct(-1); }
});
$('#expand-photo').addEventListener('click', () => {
  const expanded = $('.dialog-shell').classList.toggle('photo-expanded');
  $('#expand-photo').setAttribute('aria-pressed', String(expanded));
  $('#expand-photo span').textContent = expanded ? 'Back to details' : 'Enlarge photo';
});
$('#copy-link').addEventListener('click', async () => {
  if (!activeProduct) return;
  const version = copyVersion;
  const url = `${location.origin}${location.pathname}${location.search}#design=${activeProduct.id}`;
  try {
    await navigator.clipboard.writeText(url);
    if (version === copyVersion) $('#copy-status').textContent = 'Design link copied.';
  } catch {
    if (version === copyVersion) $('#copy-status').textContent = `Copy this link: ${url}`;
  }
});

function restoreFromHash() {
  const id = new URLSearchParams(location.hash.slice(1)).get('design');
  if (id && getProduct(id)) showProduct(id, false);
  else if (dialog.open) closeProduct(false);
}
window.addEventListener('hashchange', restoreFromHash);

function readBasket() {
  try { return cleanBasket(JSON.parse(localStorage.getItem(basketStorageKey))); }
  catch { return {}; }
}

function saveBasket() {
  try { localStorage.setItem(basketStorageKey, JSON.stringify(basket)); }
  catch { /* The basket still works for this visit when storage is unavailable. */ }
}

function renderBasket() {
  basket = cleanBasket(basket);
  const totals = basketTotals(basket);
  $('#basket-count').textContent = String(totals.quantity);
  $('#open-basket').setAttribute('aria-label', `Open basket, ${totals.quantity} ${totals.quantity === 1 ? 'item' : 'items'}`);
  $('#basket-items').innerHTML = Object.entries(basket).map(([id, quantity]) => {
    const product = getProduct(id);
    return `<article class="basket-item"><img src="https://cdn.shopify.com/s/files/1/1088/3819/1436/files/jacobs-lightboxes-${id}.jpg" alt="${escapeHTML(product.name)} lightbox" width="100" height="90"><div class="basket-item-content"><h3>${escapeHTML(product.name)}</h3><p>${money(catalog[id].pricePence)} each</p><div class="basket-item-actions"><div class="quantity-control"><button type="button" data-basket-action="minus" data-basket-id="${id}" aria-label="Decrease ${escapeHTML(product.name)} quantity">−</button><span aria-label="Quantity">${quantity}</span><button type="button" data-basket-action="plus" data-basket-id="${id}" aria-label="Increase ${escapeHTML(product.name)} quantity" ${quantity >= 99 ? 'disabled' : ''}>+</button></div><button class="remove-item" type="button" data-basket-action="remove" data-basket-id="${id}" aria-label="Remove ${escapeHTML(product.name)} from basket">Remove</button></div></div><strong class="basket-line-total">${money(catalog[id].pricePence * quantity)}</strong></article>`;
  }).join('');
  $('#basket-empty').hidden = totals.quantity > 0;
  $('#basket-summary').hidden = totals.quantity === 0;
  $('#basket-subtotal').textContent = money(totals.subtotal);
  $('#basket-postage').textContent = money(totals.postage);
  $('#basket-total').textContent = money(totals.total);
  const ready = checkoutReady(basket);
  $('#checkout-button').disabled = !ready;
  $('#checkout-button').textContent = ready ? `Checkout securely — ${money(totals.total)}` : 'Checkout opens at launch';
  $('#checkout-note').textContent = ready ? 'Your delivery address and payment are completed securely in Shopify. The final total is confirmed at checkout.' : 'You can try the basket in this private preview. Ordering will open when the shop launches.';
  $('#basket-live-status').textContent = `${totals.quantity} items. Basket total ${money(totals.total)}, including UK postage and packaging.`;
}

function openBasket() {
  if (dialog.open) closeProduct();
  basketReturnFocus = document.activeElement;
  renderBasket();
  if (!basketDialog.open) basketDialog.showModal();
  document.body.classList.add('modal-open');
  $('#close-basket').focus();
}

function closeBasket() {
  if (!basketDialog.open) return;
  basketDialog.close();
  document.body.classList.remove('modal-open');
  if (basketReturnFocus && document.contains(basketReturnFocus)) basketReturnFocus.focus({preventScroll:true});
}

function purchaseQuantity() {
  const value = Number($('#detail-quantity').value);
  return Number.isFinite(value) ? Math.max(1, Math.min(99, Math.floor(value))) : 1;
}

function updatePurchaseQuantity(change = 0) {
  const value = Math.max(1, Math.min(99, purchaseQuantity() + change));
  $('#detail-quantity').value = String(value);
  $('#quantity-minus').disabled = value === 1;
  $('#quantity-plus').disabled = value === 99;
}

$('#quantity-minus').addEventListener('click', () => updatePurchaseQuantity(-1));
$('#quantity-plus').addEventListener('click', () => updatePurchaseQuantity(1));
$('#detail-quantity').addEventListener('change', () => updatePurchaseQuantity());
$('#add-to-basket').addEventListener('click', () => {
  if (!activeProduct) return;
  const id = activeProduct.id;
  const existing = basket[id] || 0;
  basket[id] = Math.min(99, existing + purchaseQuantity());
  saveBasket();
  renderBasket();
  const added = basket[id] - existing;
  $('#add-status').textContent = added ? `${added} added to your basket.` : 'The maximum quantity is 99 per design.';
  $('#view-basket').hidden = false;
});
$('#open-basket').addEventListener('click', openBasket);
$('#view-basket').addEventListener('click', openBasket);
$('#close-basket').addEventListener('click', closeBasket);
$('#continue-shopping').addEventListener('click', closeBasket);
basketDialog.addEventListener('cancel', event => { event.preventDefault(); closeBasket(); });
basketDialog.addEventListener('click', event => {
  if (event.target !== basketDialog) return;
  const rect = basketDialog.getBoundingClientRect();
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeBasket();
});
$('#basket-items').addEventListener('click', event => {
  const button = event.target.closest('[data-basket-action]');
  if (!button || button.disabled) return;
  const id = button.dataset.basketId;
  if (!Object.hasOwn(basket, id)) return;
  if (button.dataset.basketAction === 'remove') delete basket[id];
  else if (button.dataset.basketAction === 'plus') basket[id] = Math.min(99, basket[id] + 1);
  else if (button.dataset.basketAction === 'minus') { basket[id]--; if (!basket[id]) delete basket[id]; }
  saveBasket();
  renderBasket();
  // Rendering replaces the controls. Restore keyboard focus to the matching control.
  const replacement = $('#basket-items').querySelector(`[data-basket-id="${id}"][data-basket-action="${button.dataset.basketAction}"]`);
  (replacement || $('#close-basket')).focus({preventScroll:true});
});
$('#checkout-button').addEventListener('click', () => {
  if (!checkoutReady(basket)) return;
  const url = checkoutURL(basket);
  if (url) location.assign(url);
});
window.addEventListener('storage', event => {
  if (event.key === basketStorageKey || event.key === null) { basket = readBasket(); renderBasket(); }
});
$('#review-banner').hidden = shop.checkoutEnabled;
renderGallery();
renderBasket();
restoreFromHash();

})();